import HorizontalLinearStepper from "@/views/elements/HorizontalLinearStepper";
import WrapperModal from "@/views/elements/WrapperModal";
import { useState } from "react";
import RegisterMasterModalStep1 from "./RegisterMasterModalStep1";
import RegisterMasterModalStep2 from "./RegisterMasterModalStep2";
import RegisterMasterModalStep3 from "./RegisterMasterModalStep3";
import ToastUtil from "@/views/components/Toast/Toast";
import { useTranslation } from "react-i18next";
import { setStatusRegisterMFAction } from "@/stores/dataManager/Actions/appAction";

type RegisterMasterModalProps = {
  open: boolean;
  handleClose: () => void;
};

const RegisterMasterModal = ({
  open,
  handleClose,
}: RegisterMasterModalProps) => {
  const { t } = useTranslation()
  const [step, setStep] = useState(1);
  const [data, setData] = useState({
    baldefovd: "",
    monthtraded: "",
    netasset: "",
    minmonthtraded: "",
    custodycd: "",
    minnetasset: "",
  });

  const STEPS = [t('copytrade.common.info'), t('copytrade.common.confirm'), t('copytrade.common.finished')];

  const handleBackStep = () => {
    if (step !== 0) {
      setStep((prevStep) => prevStep - 1);
    }
  };

  const handleNextStep1 = (data: any) => {
    try {
      setStatusRegisterMFAction(null)
      if (data.netasset < data.minnetasset) {
        ToastUtil.error(t('copytrade.registerMaster.minassetError'))
        return
      }
      setData((prev) => ({ ...prev, ...data }));
      setStep((prevStep) => prevStep + 1);
    } catch (error) {
      console.log(error)
      ToastUtil.error('')
    }
  };

  const handleNextStep2 = (data: any) => {
    setData((prev) => ({ ...prev, ...data }));
    setStep((prevStep) => prevStep + 1);
  };

  return (
    <WrapperModal
      open={open}
      handleClose={handleClose}
      title={t('copytrade.registerMaster.modalTitle')}
    >
      <HorizontalLinearStepper steps={STEPS} activeStep={step - 1} />
      {step === 1 && (
        <RegisterMasterModalStep1
          handleClose={handleClose}
          handleNextStep={handleNextStep1}
        />
      )}
      {step === 2 && (
        <RegisterMasterModalStep2
          data={data}
          handleClose={handleClose}
          handleBackStep={handleBackStep}
          handleNextStep={handleNextStep2}
        />
      )}
      {step === 3 && <RegisterMasterModalStep3 handleClose={handleClose} />}
    </WrapperModal>
  );
};

export default RegisterMasterModal;
